// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__HcC8J","loading_spinne":"styles_loading_spinne__XJYzd","spin":"styles_spin__CQ6kY"};